import { Field, Formik } from "formik";
import { isEmpty } from "lodash";
import React, { useState } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useRequest, useRouterParams, useDeepEffect } from "../../../abstracts";
import {
  DatePicker,
  FieldDropSide,
  ManageCensusLayout,
  MultiSelectDropdown,
  CsplTable as Table,
  Link,
} from "../../../components";
import { getCensusHistory } from "../../../services";
import {
  FLOW_TYPES,
  formFields,
  manageCensusFormNames,
  toMultiSelectValueById,
  usDateFormat,
  censusFormFields,
} from "../../../utils";
import { useContext } from "react";
import {
  manageCensusStore,
  setManageCensusPageLevelData,
} from "../../../contexts";
import moment from "moment";
import AddToolTip from "../../../components/AddToolTip";

const columns = [
  {
    label: "Field",
    className: "column-field",
    columnName: "field",
  },
  {
    label: "Date/Time Modified",
    className: "column-dateTimeModified",
    columnName: "dateTimeModified",
  },
  {
    label: "Previous Value",
    className: "column-previousValue",
    columnName: "previousValue",
  },
  {
    label: "Updated Value",
    className: "column-updatedValue",
    columnName: "updatedValue",
  },
  {
    label: "Uploaded Through",
    className: "column-updatedThrough",
    columnName: "uploadedThrough",
  },
  {
    label: "Comments",
    className: "column-comments",
    columnName: "comments",
    link: `link`,
  },
];

const fieldsOptions = [
  {
    value: 1,
    label: "Employee ID",
  },
  {
    value: 2,
    label: "Name",
  },
  {
    value: 3,
    label: "Social Security Number",
  },
  {
    value: 4,
    label: "Gender",
  },
  {
    value: 5,
    label: "Marital Status",
  },
  {
    value: 6,
    label: "Date of Birth",
  },
  {
    value: 7,
    label: "Hire Date",
  },
  {
    value: 8,
    label: "Most Recent Rehire Date",
  },
  {
    value: 9,
    label: "Most Recent Term Date",
  },
  {
    value: 10,
    label: "Employment Status",
  },
  {
    value: 11,
    label: "Payroll Frequency",
  },
  {
    value: 12,
    label: "Address",
  },
  {
    value: 13,
    label: "Primary Phone Number",
  },
  {
    value: 14,
    label: "Secondary Phone Number",
  },
  {
    value: 15,
    label: "Email",
  },
  {
    value: 16,
    label: "HCE",
  },
  {
    value: 17,
    label: "Employee Classification",
  },
  {
    value: 18,
    label: "Rehire Date (History)",
  },
  {
    value: 19,
    label: "Termination Date (History)",
  },
];
var fromDate = new Date();
fromDate.setDate(fromDate.getDate() - 365);
fromDate = usDateFormat(fromDate);
const toDate = usDateFormat(new Date());

const initialValues = {
  startDate: fromDate,
  endDate: toDate,
};

const ManageCensusHistoryContainer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [censusHistory, setcensusHistory] = useState([]);
  const [toggle, setToggle] = useState(false);
  const { state, dispatch } = useContext(manageCensusStore);
  const { censusId } = useRouterParams();
  const formName = manageCensusFormNames.CENSUS_HISTORY;
  const fields = formFields[formName];
  useDeepEffect(() => {
    setIsLoading(true);
    getCensusHistory({
      employeeId: censusId,
      startDate: fromDate,
      endDate: toDate,
    }).then((response) => {
      setcensusHistory(response);
      setIsLoading(false);
    });
  }, [toggle]);
  const onFormSubmit = (values) => {
    setIsLoading(true);
    getCensusHistory({
      ...values,
      startDate: values.startDate === "" ? null : values.startDate,
      endDate: values.endDate === "" ? null : values.endDate,
      employeeId: censusId,
    })
      .then((response) => {
        setIsLoading(false);
        setcensusHistory(response);
        dispatch(
          setManageCensusPageLevelData({
            formName: formName,
            fieldData: values,
          })
        );
      })
      .catch((error) => {
        setIsLoading(false);
        throw error;
      });
  };

  return (
    <ManageCensusLayout pageFlow={FLOW_TYPES.EDIT}>
      <div className="w-100">
        <Formik
          initialValues={initialValues}
          onSubmit={onFormSubmit}
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({ handleChange, setFieldValue, handleSubmit, values, ...rest }) => {
            const onDaySelected = (fieldName, value) => {
              setFieldValue(fieldName, value);
            };
            const selectedFields = values[fields.fields];
            return (
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
              >
                {/* <div className="d-flex justify-content-between compensation-container w-100"> */}
                <div className="d-flex justify-content-space-between w-100">
                  <div
                    style={{ marginTop: "3.3%" }}
                    className="plan-sub-heading"
                  >
                    Show records of period
                  </div>
                  <Field
                    size="sm"
                    label="Start Date"
                    name={fields.startDate}
                    value={usDateFormat(values[fields.startDate])}
                    isDatePicker
                    onClear={() => onDaySelected(fields.startDate, "")}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.startDate, value)
                        }
                        value={usDateFormat(values[fields.startDate])}
                      />
                    }
                    direction="bottom"
                    component={FieldDropSide}
                  />
                  <Field
                    size="sm"
                    label="End Date"
                    name={fields.endDate}
                    value={usDateFormat(values[fields.endDate])}
                    isDatePicker
                    onClear={() => onDaySelected(fields.endDate, "")}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.endDate, value)
                        }
                        value={usDateFormat(values[fields.endDate])}
                      />
                    }
                    direction="bottom"
                    validate={(value) => {
                      return [undefined, null, ""].includes(value) ? (
                        ""
                      ) : new Date(value) <=
                        new Date(values[fields.startDate]) ? (
                        <div style={{ width: "150px" }}>
                          Should be ahead of "Start Date"
                        </div>
                      ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                      undefined;
                    }}
                    component={FieldDropSide}
                  />
                  <Field
                    size="smd"
                    label="fields"
                    name={fields.fields}
                    value={toMultiSelectValueById(
                      values[fields.fields],
                      fieldsOptions
                    )}
                    isMultiSelect
                    popupContent={
                      <MultiSelectDropdown
                        label="Fields"
                        name={fields.fields}
                        onSelect={(value) =>
                          setFieldValue(fields.fields, value)
                        }
                        value={values[fields.fields]}
                        height={"350px"}
                        options={fieldsOptions}
                      />
                    }
                    direction="bottom"
                    component={FieldDropSide}
                  />
                  <Button
                    type="submit"
                    style={{ height: "8%", marginTop: "2.7%" }}
                    className="align-center"
                  >
                    Go
                  </Button>
                  <div style={{ marginTop: "3.5%" }} className="mr-4">
                    {censusHistory.length} records
                  </div>
                </div>
                {/* </div> */}
              </Form>
            );
          }}
        </Formik>
        <Table isLoading={isLoading} className="contributions-table">
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {censusHistory &&
              censusHistory.map((contributions, index) => {
                return (
                  <Table.Tr key={index}>
                    {columns.map((item, cellIndex) => {
                      const getContent = () => {
                        if (!isEmpty(item.link)) {
                          return contributions[item.columnName] ? (
                            <OverlayTrigger
                              overlay={
                                <Tooltip>{contributions.tooltip}</Tooltip>
                              }
                            >
                              <Link>{contributions[item.columnName]}</Link>
                            </OverlayTrigger>
                          ) : (
                            "-"
                          );
                        }
                        if (item.dataMapper) {
                          return item.dataMapper[
                            contributions[item.columnName]
                          ];
                        }
                        if (item.columnName == "uploadedThrough") {
                          return contributions[item.columnName];
                        }
                        if (item.columnName == "dateTimeModified") {
                          return (
                            moment(
                              new Date(contributions[item.columnName])
                            ).format("MM-DD-YYYY") +
                            " " +
                            moment(
                              new Date(contributions[item.columnName])
                            ).format("HH:mm")
                          );
                        } else
                          return (
                            <AddToolTip
                              name={contributions[item.columnName] || "-"}
                              placement="bottom"
                            >
                              {contributions[item.columnName] || "-"}
                            </AddToolTip>
                          );
                      };
                      return (
                        <Table.Td key={cellIndex} className={item.className}>
                          {getContent()}
                        </Table.Td>
                      );
                    })}
                  </Table.Tr>
                );
              })}
          </Table.Tbody>
        </Table>
      </div>
    </ManageCensusLayout>
  );
};

export default ManageCensusHistoryContainer;
